import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectSelectedProject,
  selectSelectedProjectId,
} from 'store/projects/selectors/projectsSelectors';
import { postCreateFirestopList } from '../services/post-create-firestop-list.service';

export const createFirestopList = createAsyncThunk(
  'defectLists/createFirestopList',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const selectedProject = selectSelectedProject(getState());

    const listAttributes = {
      name: `${selectedProject.name}, palokatkodokumentaatio`,
    };

    const createdListData = await postCreateFirestopList(
      selectedProjectId,
      listAttributes
    );

    return createdListData;
  }
);
